<mat-form-field class="item">
    <mat-label>{{title}}</mat-label>
    <input matInput [ngModel]="date" [matDatepicker]="picker" (ngModelChange)="onChange($event)" (click)="picker.open()">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
